export const PAGINATION_SIZE = 30;
export const ROOM_TYPE_PEOPLE = 'people';
export const ROOM_TYPE_PROJECTS = 'projects';
export const MESSAGE_TYPE_WIDGET = 'widget';
export const DEFAULT_PROFILE_IMAGE = '/assets/images/profile-placeholder.png';
export const DEFAULT_GROUP_IMAGE = '/assets/images/profile-placeholder.png';
export const TMP_ROOM_ID = 'tmpRoomId';
